import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { useTooltipContext } from './TooltipContext';
import { InfoIcon } from '../Icons/InfoIcon';

interface TooltipContentProps {
  children: ReactNode;
}

export const TooltipContent: React.FC<TooltipContentProps> = ({ children }) => {
  const { open, refs, x, y, strategy } = useTooltipContext();

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      ref={refs.setFloating}
      style={{
        position: strategy,
        top: y ?? 0,
        left: x ?? 0,
        zIndex: 9999,
        maxWidth: 400,
      }}
      className="flex gap-2 bg-white text-[#4D4E58] p-3 rounded-lg shadow-lg"
    >
      <div className="text-[#86868B]">
        <InfoIcon />
      </div>{' '}
      {children}
    </div>,
    document.body,
  );
};
